<template>
    <div>
        <modal class="pay-atm-detail" :display="modalStatus.refundDetail" @modalStatus="closeModal" >
            <h1>{{refundItem.houseName}}</h1>
            <div class="refund-head">
                <div class="title">
                    {{transSource(refundItem.source)}}
                </div>
                <div class="amount">
                    + {{toCurrency(refundItem.amount)}}
                </div>
            </div>
            <div class="pay-atm-detail-wrap">
                <div class="content">
                    <div class="list">
                        <span class="title">房源地址</span>
                        <span class="info">：{{refundItem.address}}</span>
                    </div>
                    <div class="list">
                        <span class="title">收支類別</span>
                        <span class="info">：{{transType(refundItem.type)}}</span>
                    </div>
                    <div class="list">
                        <span class="title">退款時間</span>
                        <span class="info">：{{refundItem.transactionDate}}</span>
                    </div>
                    <div class="list">
                        <span class="title">金額來源</span>
                        <span class="info">：{{refundItem.note}}</span>
                    </div>
                    <div class="list">
                        <span class="title">付款方式</span>
                        <span class="info">：{{transPayWay(refundItem.paymentType)}}</span>
                    </div>
                    <div class="list">
                        <span class="title" v-if="isReturnTaskBonus(refundItem.source)">受託人</span>
                        <span class="title" v-else>交易人</span>
                        <span class="info">：{{refundItem.tenantName}}</span>
                    </div>
                    <div class="list" v-if="isReturnTaskBonus(refundItem.source)">
                        <span class="title">委託時間</span>
                        <span class="info">：{{getFormatDate(taskDetail.taskBeginTime)}}～{{getFormatDate(taskDetail.taskEndTime)}}</span>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import { mapGetters } from 'vuex'
import { 
    apiGetWebTaskDetail,
    } from "@/apis/api.js"; 

export default {
    data () {
        return {
            taskDetail: null
        }
    },
    props:{
        refundItem: {},
    },
    // mounted() {
    //     this.$analytics.logEvent('退款詳情', { screen_name: '退款詳情'})
    // },
    watch: {
        refundItem: {
            handler: function (val) {
                if(this.isReturnTaskBonus(val.source)){
                    this.getTaskDetail(val.referenceSeq)
                }
            },
            deep: true
        }
    },
    methods: {
        closeModal: function (type) {
            this.$store.dispatch('setModalStatus', {state: false, type: 'refundDetail'})
        },
        // toCurrency: function (num){
        //     if(num){
        //         var parts = num.toString().split('.');
        //         // console.log(parts);
        //         parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //         return parts.join('.');
        //     }
        // },
        getTaskDetail: function (taskSeq) {
            let data = taskSeq

            apiGetWebTaskDetail(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.taskDetail = res.data.result
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        // transSource: function (value) {
        //     if( value == 'BOOKING_DEPOSIT' ){
        //         return '訂金'
        //     }else if( value == 'CONTRACT_DEPOSIT' ) {
        //         return '押金'
        //     }else if( value == 'CONTRACT_BILL' ) {
        //         return '帳單'
        //     }else if( value == 'HOUSE_TASK_BONUS' ) {
        //         return '委託獎金'
        //     }else if(value == 'HOUSE_LEDGER'){
        //         return '記帳'
        //     }else if(value == 'RETURN_PAID_HOUSE_TASK_BONUS'){
        //         return '委託退款'
        //     }else if(value == 'BOOKING_DEPOSIT_FOR_TENANT_REJECT'){
        //         return '取消預定'
        //     }
        // },
        // transType: function (value) {
        //     if( value == 'INCOME' ){
        //         return '收入'
        //     }else if( value == 'EXPENSE' ) {
        //         return '支出'
        //     }
        // },
        // transPayWay: function (value) {
        //     if( value == 'WALLET' ){
        //         return '飛豬錢包'
        //     }else if( value == 'TRANSFER' ) {
        //         return '匯款轉帳'
        //     }else if( value == 'TASK_REFUND' ) {
        //         return '系統退款'
        //     }else if( value == 'DEPOSIT_FORFEIT' ) {
        //         return '訂金補償'
        //     }
        // },
        getFormatDate: function (time){
            var formatDate = [];
            var date = new Date(time);
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            //月及天兩位數
            formatDate[5] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[6] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            if(formatDate[3] - 8 < 0){
                formatDate[3] = 24+(formatDate[3]-8);
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }else{
                formatDate[3] = formatDate[3]-8;
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }
            return formatDate[0]+'-'+formatDate[5]+'-'+formatDate[6];
        },
    },
    computed: {
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
    }
}
</script>
<style lang="scss"  >
    #modal.pay-atm-detail{
        .modal-content{
            width: 488px;
            padding: 0 !important;
            .detail{
                align-items: flex-start;
                >h1{
                    width: 320px;
                    text-align: center;
                    font-size: 24px;
                    margin: 32px auto 24px;
                    line-height: 1.5;
                }
                .refund-head{
                    display: flex;
                    align-items: center;
                    width: 424px;
                    height: 72px;
                    border-radius: 8px;
                    box-shadow: 2px 2px 8px 0 rgba(41, 38, 37, 0.08);
                    border: solid 1px #f3f3f3;
                    background-color: #ffffff;
                    margin: 0 32px;
                    .title{
                        padding: 0 20px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-right: 1px solid #f3f3f3;
                        color: #a8a5a4;
                        height: 72px;
                    }
                    .amount{
                        padding: 0 20px;
                        font-size: 20px;
                        color: #ff9275;
                    }
                }
                .pay-atm-detail-wrap{
                    padding: 24px 52px;
                    .content{
                        width: 385px;
                        margin-bottom: 20px;
                        .list{
                            display: flex;
                            margin-bottom: 16px;
                            .title{
                                display: block;
                                width: 56px;
                            }
                            .info{
                                width: 320px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 1;
                            }
                        }
                        .warm{
                            color: #fc7171;
                        }
                    }
                }
            }
      
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/widge/modal/refundDetail.vue